export const SignupActions = {
    SHOW_LOGIN_MODAL: '@@signup/SHOW_LOGIN_MODAL',
    CLOSE_LOGIN_MODAL: '@@signup/CLOSE_LOGIN_MODAL',
    TRIGGER_PATIENT_INFO_TRANSITION: '@@signup/TRIGGER_PATIENT_INFO_TRANSITION',
};

export const showLoginModal = () => ({
    type: SignupActions.SHOW_LOGIN_MODAL,
});

export const triggerPatientInfoTransition = () => ({
    type: SignupActions.TRIGGER_PATIENT_INFO_TRANSITION,
});

export const closeLoginModal = () => ({
    type: SignupActions.CLOSE_LOGIN_MODAL,
});
